import { createInstance } from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next/initReactI18next';

import { getOptions, fallbackLng, defaultNS } from './settings';

const initI18next = async (ns: string | undefined) => {
  const i18nInstance = createInstance();

  await i18nInstance
    .use(initReactI18next)
    .use(resourcesToBackend((language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)))
    .init(getOptions(ns));

  return i18nInstance;
};

export const useServerTranslation = async (ns = defaultNS, lng = fallbackLng, keyPrefix?: string) => {
  const i18nextInstance = await initI18next(ns);

  return {
    t: i18nextInstance.getFixedT(lng, Array.isArray(ns) ? ns[0] : ns, keyPrefix),
    i18n: i18nextInstance,
  };
};
